export default __webpack_public_path__ + "static/media/logoWhite.ea721be2.png";